/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2022-09-22 09:16:17
 * @LastEditors: linxi
 * @LastEditTime: 2022-09-28 14:41:38
 */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Modal,
  notification,
  Popconfirm,
  Row,
  Select,
} from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import {
  setAppShadeIsModal,
  setAppShadeTipText,
} from '../../layouts/layoutSlice'
import styles from './Tenants.module.css'
import {
  getCopyBatchSubmit,
  getCopyBatchSubmitSecond,
  getTemplateDetailSecond,
  getTenantList,
} from './tenantSlice'

export const TemplateCopyingModal = (props: {
  visible: boolean
  id?: any
  tenantIds?: any
  num?: any
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const { Option } = Select

  const [organizationList, setOrganizationList] = useState<any>([]) //标签数据

  const [templteData, setTemplteData] = useState<any>()

  const [selectTemplte, setSelectTemplte] = useState<any>([])

  const [total, setTotal] = useState<any>(0)

  useEffect(() => {
    if (props?.visible) {
      getOptions('')
    } else {
      setTemplteData(undefined)
      setTotal(0)
      setSelectTemplte([])
    }
  }, [props?.visible])

  const getOptions = (params = '') => {
    dispatch(
      getTenantList({
        current: 1,
        size: 500,
        name: params,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setOrganizationList(res?.items)
      })
  }

  return (
    <Modal
      width={800}
      footer={null}
      className={styles.templateCopyingModal}
      title='模板复制'
      visible={props.visible}
      onOk={() => {
        props.onOk()
        form.resetFields()
      }}
      onCancel={() => {
        props.onCancel()
        form.resetFields()
      }}
    >
      <Form
        autoComplete='off'
        form={form}
        labelCol={{
          span: 5,
        }}
        wrapperCol={{
          span: 19,
        }}
        onFinish={(fs) => {
          dispatch(setAppShadeIsModal(true))
          dispatch(setAppShadeTipText('正在处理中，请稍后~~~'))
          dispatch(
            getCopyBatchSubmitSecond({
              tenantId: fs?.tenantIdList,
              tenantIds: props?.tenantIds,
              templateIds: fs?.templateIds,
            })
          )
            .then(unwrapResult)
            .then((res: any) => {
              dispatch(setAppShadeIsModal(false))
              dispatch(setAppShadeTipText('请稍后~~~'))
              notification.success({
                message: '操作成功',
                duration: 3,
              })
              props.onOk()
              form.resetFields()
            })
            .catch(() => {
              dispatch(setAppShadeIsModal(false))
              dispatch(setAppShadeTipText('请稍后~~~'))
              notification.success({
                message: '操作失败',
                duration: 3,
              })
              props.onCancel()
              form.resetFields()
            })
        }}
      >
        <Row style={{ margin: '20px 0 0 25px' }}>
          <Col span={24}>
            <Form.Item
              label='选择一家被复制的机构'
              name='tenantIdList'
              rules={[
                {
                  required: true,
                  max: 500,
                  message: '请选择机构！',
                },
              ]}
            >
              <Select
                style={{ width: '300px' }}
                placeholder='请输入机构名称以检索'
                allowClear
                showSearch
                filterOption={false}
                onChange={(v: any) => {
                  if (v)
                    dispatch(getTemplateDetailSecond({ tenantId: v }))
                      .then(unwrapResult)
                      .then((res: any) => {
                        setTemplteData(res)
                        setTotal(res?.length)
                      })
                }}
                onSearch={(res) => {
                  getOptions(res)
                  setTemplteData(undefined)
                  setTotal(0)
                }}
              >
                {organizationList &&
                  organizationList?.map((a: any) => (
                    <Option key={a?.id} value={a?.id}>
                      {a?.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          {total == 0 ? (
            <Col span={24}>
              <p>该机构没有任何诊断模板</p>
            </Col>
          ) : (
            <Col span={24}>
              <Form.Item
                label='病历模板'
                name='templateIds'
              >
                <Select
                  style={{ width: '300px' }}
                  placeholder='请选择病历模板'
                  allowClear
                  mode="multiple"
                  onChange={((v) => {
                    setSelectTemplte(v)
                  })}
                >
                  {templteData?.map((a: any, i: number) => (
                    <Select.Option key={a?.templateId} value={a?.templateId}>
                      {a?.categoryName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              {/* <p>{directoryReplicationData?.info}</p> */}
            </Col>
          )}
        </Row>
        <Row
          style={{
            display: 'flex',
            justifyContent: 'end',
            alignItems: 'center',
            margin: '20px 0px 0 0 ',
            paddingTop: '15px',
            borderTop: '1px solid #f0f0f0',
          }}
        >
          <div
            style={{
              height: '50px',
              marginRight: '10px',
            }}
          >
            <Button
              onClick={() => {
                props.onCancel()
                form.resetFields()
              }}
            >
              取消
            </Button>
          </div>
          <div
            style={{
              height: '50px',
              marginRight: '10px',
            }}
          >
            <Popconfirm
              placement='topRight'
              title={
                '本次操作将会给选中的' +
                `${props?.num}` +
                '家机构新增' +
                `${selectTemplte?.length || 0}` +
                '个病历模板，请确认！'
              }
              onConfirm={() => {
                form.submit()
              }}
              okText='确认'
              cancelText='取消'
            >
              <Button type='primary'>确认</Button>
            </Popconfirm>
          </div>
        </Row>
      </Form>
    </Modal>
  )
}
